import { baseThemeValues } from 'constants/common';

const baseProps = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 400,
  text: 'palette.tertiary.95',
};

export const richEditorTheme = {
  buttons: {
    bg: 'palette.transparent',
    hover: {
      text: 'palette.neutral.90',
    },
    selected: {
      text: 'palette.tertiary.95',
    },
    text: 'palette.neutral.30',
  },
  error: {
    ...baseProps,
    text: 'palette.error.60',
  },
  label: {
    ...baseProps,
    fontWeight: 500,
    text: 'palette.tertiary.60',
  },
  popover: {
    ...baseProps,
    bg: 'palette.surface.5',
  },
  textArea: {
    ...baseProps,
    bg: 'palette.surface.4',
    borderColor: 'palette.tertiary.50',
    placeholder: 'palette.tertiary.50',
  },
};
